import { styled } from '@mui/material';

export const MaintenanceWrapper = styled('div')(({ theme }) => ({
    fontFamily: theme.typography.fontFamily,
    background: `linear-gradient(135deg, ${theme.palette.primary[500]} 0%, ${theme.palette.primary[600]} 50%, ${theme.palette.primary[700]} 100%)`,
    color: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: theme.spacing(2.5),
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
}));

export const Container = styled('div')(({ theme }) => ({
    textAlign: 'center',
    maxWidth: '600px',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: theme.spacing(2.5),
    padding: theme.spacing(7.5, 5),
    boxShadow: '0px 17px 20px rgba(16, 5, 51, 0.12)',
    border: `1px solid ${theme.palette.grey[200]}`,

    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(5, 3.75),
    },
}));

export const Icon = styled('div')({
    fontSize: '80px',
    marginBottom: '30px',
    '@keyframes pulse': {
        '0%, 100%': {
            transform: 'scale(1)',
            opacity: 1,
        },
        '50%': {
            transform: 'scale(1.1)',
            opacity: 0.8,
        },
    },
    animation: 'pulse 2s ease-in-out infinite',
});

export const Title = styled('h1')(({ theme }) => ({
    fontSize: '2.5rem',
    marginBottom: theme.spacing(2.5),
    fontWeight: 700,
    color: theme.palette.grey[800],

    [theme.breakpoints.down('sm')]: {
        fontSize: '2rem',
    },
}));

export const Description = styled('p')(({ theme }) => ({
    fontSize: '1.125rem',
    lineHeight: 1.6,
    marginBottom: theme.spacing(1.875),
    color: theme.palette.grey[700],

    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
    },
}));

export const StatusBox = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(5),
    padding: theme.spacing(2.5, 3.75),
    background: theme.palette.primary[50],
    borderRadius: theme.spacing(1.25),
    display: 'inline-block',
    border: `1px solid ${theme.palette.primary[100]}`,
}));

export const StatusText = styled('span')(({ theme }) => ({
    fontSize: '0.875rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: theme.palette.primary[700],
}));
